import { TextButton } from '@amzn/storm-ui';
import React from 'react';
import styled from 'styled-components';
import { Breadcrumb } from '../../../../app/slice';
import { gray500 } from '../../../../colors';
import { getBreadcrumbLabel } from './breadcrumbsHelper';
import { StyledLink } from './style';

const StyledTextButton = styled(TextButton)`
  text-decoration: none;
  &:focus {
    outline-offset: -1px;
  }

  &:hover {
    text-decoration: underline;
  }
  &&& + span {
    color: ${gray500};
    margin-bottom: -2px;
  }
`;

export const LinkBreadcrumb: React.FC<{ breadcrumb: Breadcrumb }> = ({
  breadcrumb,
}) => {
  if (breadcrumb.onClickCallback) {
    return (
      <StyledTextButton onClick={breadcrumb.onClickCallback}>
        {getBreadcrumbLabel(breadcrumb)}
      </StyledTextButton>
    );
  }

  return (
    <StyledLink href={breadcrumb.url} ia2Enabled={true}>
      {getBreadcrumbLabel(breadcrumb)}
    </StyledLink>
  );
};
